<template>
  <div :class="showSwitcher ? 'pkd-root' : ''">
    <div v-if="showSwitcher" @click="switcher = !switcher" class="switcher" ref="switcher">
      <div>
        <span v-show="switcher">
          <i class="fa fa-sort-alpha-asc"></i> Zmień metodę wprowadzania
        </span>
        <span v-show="!switcher">
          <i class="fa fa-sort-numeric-asc"></i> Zmień metodę wprowadzania
        </span>
      </div>
    </div>
    <w-vue-select
      ref="select"
      :model="model"
      :values="showedOptions"
      :searchable="true"
      @input="fixLabels"
      :class="showSwitcher ? 'pkd-list' : ''"
      :placeholder="name + ' PKD...'"
    >
      <span name="no-options">Przepraszamy, nie znaleziono podanego numeru PKD.</span>
    </w-vue-select>
  </div>
</template>

<script>
import axios from 'axios';

import WVueSelect from './vue-select.vue';
import modelMixin from '../mixins/modelMixin';

export default {
  name: 'pkd-select',
  components: {WVueSelect},
  mixins: [modelMixin],
  data() {
    return {
      options: [],
      showedOptions: [],
      switcher: !this.showSymbolsFirst
    };
  },
  props: {
    url: {
      type: String,
      default: 'https://pkd.api.witkac.pl'
    },
    count: {
      type: Number,
      default: 999
    },
    showSwitcher: {
      type: Boolean,
      default: true
    },
    showSymbolsFirst: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    name() {
      if (this.switcher) return this.areManyItems ? 'Nazwy' : 'Nazwa';
      else return this.areManyItems ? 'Symbole' : 'Symbol';
    },
    modelIsAnArray() {
      return this.model.$schema.type === 'array';
    },
    areManyItems() {
      return this.modelIsAnArray && this.model.$items.length > 1;
    }
  },
  methods: {
    getOptions() {
      axios
        .get(`${this.url}/?count=${this.count}`)
        .then(res => {
          this.options = res.data.list.map(item => ({Value: item.symbol, Text: item.nazwa}));
        })
        .catch(error => this.$emit('error', 'Nie udało się pobrać listy PKD'));
    },
    getShowedOptions() {
      if (this.switcher) this.showedOptions = this.options;
      else this.showedOptions = this.options.map(item => ({Value: item.Value, Text: item.Value}));
    },
    fixLabels(val) {
      if (!this.switcher)
        if (this.modelIsAnArray) {
          for (let i = 0; i < val.length; i++) {
            let item = this.options.find(x => x.Value == val[i].Value);
            this.model.$value[i].Text = item.Text;
          }
        } else if (this.model.$schema.type == 'object') {
          let Text = this.options.find(x => x.Value == val.Value).Text;
          this.$set(this.model.$value, 'Text', Text);
        }
    },
    setSwitcher() {
      if (this.$refs.switcher && this.$refs.select) this.$refs.select.$children[0].$el.append(this.$refs.switcher);
    }
  },
  watch: {
    options: {
      handler() {
        return this.getShowedOptions();
      },
      immediate: true
    },
    switcher: {
      handler() {
        this.$emit('switcher', this.switcher);
        return this.getShowedOptions();
      }
    },
    showSymbolsFirst: {
      handler() {
        this.switcher = this.showSymbolsFirst;
      },
      immediate: true
    }
  },
  beforeMount() {
    this.getOptions();
  },
  mounted() {
    this.setSwitcher();
  }
};
</script>
<style>
.pkd-root {
  position: relative;
}
.switcher {
  vertical-align: middle !important;
  position: absolute !important;
  z-index: 1;
  left: 1px;
  top: 1px;
  cursor: pointer;
  color: #333;
  background-color: #ebebeb;
  border-right: 1px solid #cdcdcd;
  width: 200px;
  padding: 5px 5px 4.5px 5px !important;
  border-radius: 4px 0px 0px 4px;
  /* height: calc(100% - 1.5px); */
}
.switcher:hover {
  background-color: #e0e0e0;
}
.pkd-list .vs__selected-options {
  margin-left: 210px;
}
.noborderdisabled td.input .v-select .switcher {
  border-radius: 0px;
  top: -6.5px;
  left: -2.5px;
  width: 202.5px;
  height: calc(100% + 20px);
}
.noborderdisabled td.input .v-select .switcher > div {
  position: relative;
  height: 100%;
}
.noborderdisabled td.input .v-select .switcher > div > span {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
</style>
